import { useQuery } from '@tanstack/react-query'

import { fetchHighlightedIdeas } from '../api/fetchers/fetchIdeas'

export const useHighlightedIdeas = (params: any) => {
  return useQuery({
    queryKey: ['highlightedIdeas', params],
    queryFn: async ({ signal }) => {
      const res: any = await fetchHighlightedIdeas(params)(signal)
      return res.data.data
    },
  })
}
